export default "__VITE_ASSET__DdPBBoa5__"